var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showLocationModal ? _c('Modal', {
    staticClass: "prevent-ptr",
    attrs: {
      "title": _vm.$t('weather.setLocation')
    },
    on: {
      "close": _vm.handleCloseModal
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('div', {
          staticClass: "location-modal-content"
        }, [_c('LocationSelector', {
          model: {
            value: _vm.tempCoordinates,
            callback: function ($$v) {
              _vm.tempCoordinates = $$v;
            },
            expression: "tempCoordinates"
          }
        }), _c('div', {
          staticClass: "modal-actions"
        }, [_c('button', {
          staticClass: "btn btn-secondary",
          on: {
            "click": _vm.handleCloseModal
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]), _c('button', {
          staticClass: "btn btn-primary",
          on: {
            "click": _vm.handleSaveLocation
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")])])], 1)];
      },
      proxy: true
    }], null, false, 2196233470)
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }